







import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import VoteList from '../components/VoteList.vue';
@Component({
  components: {
    SearchBar,
    VoteList,
  },
})
export default class Exhibition extends Vue {
  activeType = '1';
  // tab = [
  //   { text: '重庆科技创新人物', id: '1' },
  //   { text: '西部科学城科技创新领军人物', id: '2' },
  // ];

  search = '';

  changeTab(item: any) {
    this.activeType = item.id;
  }
}
